import { capitalCase } from 'change-case';
import { Link as RouterLink } from 'react-router-dom';
// @mui
import { styled } from '@mui/material/styles';
import { Box, Typography, Stack, Grid } from '@mui/material';
// components
import Image from '../../components/Image';
// sections
import { ChangePasswordForm } from '../../sections/auth/change-password';
import useLocales from '../../hooks/useLocales';

// ----------------------------------------------------------------------

const ContentStyle = styled(Stack)(({ theme }) => ({
  // maxWidth: 480,
  // minHeight: '100vh',
  alignItems: 'center',
  flexDirection: 'column',
  padding: theme.spacing(2),
  background: 'linear-gradient(0deg, #C4C4C4, #FCFCFC, #D2D2D2)',
}));

// ----------------------------------------------------------------------

export default function ChangePassword() {
  // const { currentTab, setCurrentTab } = useTabs('0');
  const { translate } = useLocales();

  return (
    <ContentStyle spacing={4}>
      <Typography color="#474747" className="gold-text" variant="h4" fontWeight={900}>
        {translate('change_password')}
      </Typography>

      <ChangePasswordForm />
    </ContentStyle>
  );
}
